import merge from 'lodash/merge';

import { useSmartrrTheme } from "@customer-app/account/views/OperationAquarius/hooks/useSmartrrTheme";

export const useThemeConditionals = () => {
  const theme = useSmartrrTheme();
  const themeConditionalActions = merge(
    theme.modernThemeSettings?.subscriptionActions,
    theme.modernThemeSettings?.nextOrderActions
  );
  const areThemeConditionalActions = Object.values(themeConditionalActions!).filter(item => item).length;

  return { themeConditionalActions, areThemeConditionalActions };
};
